export type Translation = {
    language: string
    text: string
};

export function filter<T>(
    items: T[],
    ...itemSelectors: Array<(translation: T) => boolean>
): T[] {
    for (const itemSelector of itemSelectors) {
        const match = items?.filter?.(itemSelector);
        if (match?.length) return match;
    }
    return [];
}

export function filterByLanguage(translations: Translation[], language: string = undefined) {
    return filter<Translation>(
        translations,
        (translation: Translation) => language === undefined || translation.language === language,
        (translation: Translation) => translation.language === "en",
        () => true,
    );
}

export function findByLanguage(translations: Translation[], language: string) {
    return filterByLanguage(translations, language)[0];
}

export default function translate(translations: Translation[], language: string = "en") {
    return findByLanguage(translations, language)?.text;
}
